import * as React from 'react';
import {
  Box,
  Button,
  Chip,
  Link,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { BackArrowIcon, HighDemandIcon, TopRatingIcon, TrendingIcon, EyeIcon, DotsIcon, UsersIcon } from '../icons';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { GlobalStyles } from '@mui/material';
import UniversitySummary from '../components/university-table/UniversitySummary';
import websiteLeadsData from '../components/WebsiteLead/data';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import '../../src/assets/css/admission.css'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNotification } from '../hooks/useNotification';
import { assignCounselorToWebLead, fetchAllUtmType, fetchAllWebLeads } from '../api/webLeadsApi';
import { setPaginationFiled } from '../containers/pagination-container/reducer/paginationSlice';
import CommonTableFormat from '../components/common/CommonTableFormat';
import CommonFilterTab from '../components/common/CommonFilterTab';
import UpdateWebLeadStatus from '../components/leads/webLeads/UpdateWebLeadStatus';
import AssignWebLeadCounsellor from '../components/leads/webLeads/AssignWebLeadCounsellor';
import { fetchCouncilorList } from '../api/callScheduleApi';
import { setCouncilorList } from '../containers/schedule-call-container/reducer/scheduleCallSlice';
import { formatMultiQueryParams, getStatusColors, jsonParserFormatter } from '../utils/helperFunction';
import AssignCouncilorModal from '../components/councilor/AssignCouncilorModal';
import { setFilterField } from '../containers/filter-container/reducer/filterSlice';
import { defaultPaginationValues, filterTypeOptions, webLeadsStatusList } from '../utils/constant';
import CommonDataTable from '../components/common/CommonDataTable';

const WebsiteLead = ({activeTab}) => {
  const filterSlice = useSelector(state => state.filter?.filters)
  const LOCATION_FILTER = `filters_${activeTab}:${window.location.pathname}`
  const dispatch = useDispatch()
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const navigate = useNavigate();
  const [selectedLead, setSelectedLead] = React.useState(null);
  const [updateStatusOpen, setUpdateStatusOpen] = React.useState(false);
  const [assignOpen, setAssignOpen] = React.useState(false);
  const [searchFilter, setSearchFilter] = React.useState({})
  const [rowCount, setRowCount] = React.useState(0);
  const { showSuccessNotification, showErrorNotification, } = useNotification()
  const [utmTypeList, setUtmTypeList] = React.useState([]);
  const [pageFilters, setPageFilters] = React.useState(defaultPaginationValues);
  const [isRender, setIsRender] = React.useState(false)

  const handleFliterSliceChange = (values = {}, isReset = false) => {
    let isQuery = typeof values === "object" && Object.keys(values)?.length
    isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
  }


  const fetchDetails = () => {
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchAllWebLeads({ setRows, filterData: { ...searchFilter, ...multiFilter, isMultiFilter: true  }, setRowCount, setLoading })
      .catch(error => {
        showErrorNotification(error?.message)
      })
  }

  const fetchUtmDetails = () => {
    fetchAllUtmType({ setUtmTypeList })
      .catch(error => {
        showErrorNotification(error?.message)
      })
  }

  React.useEffect(() => {
    fetchDetails()
  }, [filterSlice[LOCATION_FILTER], isRender])

    // handle extra filter tabs changes
    React.useEffect(() => {
      if (pageFilters?.page) {
        handleFliterSliceChange({ page: 0 })
      } else {
        setIsRender(!isRender)
      }
    }, [searchFilter])
  
    // parse page filters
    React.useEffect(() => {
      const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
      setPageFilters(values)
    }, [filterSlice[LOCATION_FILTER]])

  React.useEffect(() => {
    fetchUtmDetails()
  }, [])


  const handLeadPageClick = (params) => {
    params?.row?.leadId && navigate(`/leads/web/${params?.row?.leadId}`); // Navigates to the /dashboard route
  };

  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60, // fixed small width for serial number
      sortable: false,
      filterable: false,
      disableColumnMenu: false,
      // renderCell: (params) => rows?.findIndex((r) => r.id === params.row.id) + 1,
    },
    {
      field: 'leadId',
      headerName: 'Lead ID',
      flex: 1,
      minWidth: 130,
      cellClassName: 'sticky-col-1',
      headerClassName: 'sticky-col-1',
      filterColumnName: "lead_details.leadId",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { status } = params.row;
        const { brdColor } = getStatusColors(status);

        return loading ? (
          <Skeleton width={70} />
        ) : (
          <Box>
            <Typography sx={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '20px', color: '#1075FF' }}>
              <FiberManualRecordIcon
                sx={{
                  fontSize: '10px',
                  color: brdColor,
                  backgroundColor: brdColor,
                  borderRadius: '50%',
                }}
              />
              {params.value}
            </Typography>
          </Box>


        );
      },
    }
    ,
    {
      field: 'name',
      headerName: 'Student Name',
      flex: 2,
      minWidth: 250,
      filterColumnName: "fullName",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { logo, name, phone } = params.row;

        const getInitials = (fullName) => {
          if (!fullName) return '';
          const words = fullName.trim().split(' ').filter(Boolean);
          if (words.length === 1) return words[0][0]?.toUpperCase() || '';
          if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
          return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
        };

        const stringToColor = (str) => {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
          }
          const c = (hash & 0x00ffffff).toString(16).toUpperCase();
          return '#' + '00000'.substring(0, 6 - c.length) + c;
        };

        const bgColor = stringToColor(name || 'Course');

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer', marginTop: '10px' }}

          >
            {logo ? (
              <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: '#1075FF26',
                  color: '#1C74ED',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(name)}
              </Box>
            ) : (
              <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: '#1075FF26',
                  color: '#1C74ED',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '14px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(name)}
              </Box>
            )}
            <Box>
              <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#000' }}>
                {params.value}
              </Typography>
              {phone && (
                <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#363853' }}>
                  {phone}
                </Typography>
              )}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 2,
      minWidth: 250,
      filterColumnName: "email",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { email, mobile } = params.row;
        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', height: '100%' }}>
            <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#000' }}>
              <MailOutlinedIcon sx={{ color: '#363853', fontSize: '18px', marginRight: '4px' }} /> {email}
            </Typography>
            {mobile && (
              <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#363853' }}>
                <LocalPhoneOutlinedIcon sx={{ color: '#363853', fontSize: '18px', marginRight: '4px' }} />  {mobile}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: 'course',
      headerName: 'Course',
      flex: 1,
      cellClassName: 'sticky-col-1 text-center ',
      headerClassName: 'sticky-col-1 text-center leadcourcecenter',
      minWidth: 300,
       filterColumnName: "lead_details.courseInterest",
      filterType: filterTypeOptions.string,
      renderCell: (params) =>
        loading ? (
          <Skeleton variant="circular" width={24} height={24} />
        ) : (
          <Chip label={params.value} sx={{ background: '#DFEDFF', color: '#363853' }} />
        ),
    },
    {
      field: 'date',
      headerName: 'Date',
      flex: 2,
      minWidth: 130,
    filterColumnName: "createdAt",
      filterType: filterTypeOptions.dateRange,
      renderCell: (params) => {
        const { date, time } = params.row;
        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box sx={{ marginTop: '10px' }}>
            <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#000' }}>
              {date}
            </Typography>
            {date && (
              <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#363853' }}>
                {time}
              </Typography>
            )}
          </Box>
        );
      },
    },
        {
          field: 'dob',
          headerName: 'Date of Birth',
          flex: 1.2,
          minWidth: 160,
          cellClassName: 'fw-bold',
          filterColumnName: "dob",
          filterType: filterTypeOptions.dateRange,
        },
            {
              field: 'gender',
              headerName: 'Gender',
              flex: 1.2,
              minWidth: 160,
              cellClassName: 'fw-bold',
              filterColumnName: "gender",
              filterType: filterTypeOptions.string,
              renderCell: (params) => {
                const { gender } = params.row;
                return loading ? (
                  <Skeleton width={150} />
                ) : (
                  <Box display="flex" sx={{ height: '100%', flexDirection: 'column', justifyContent: 'center', }}>
                    <Typography sx={{ fontSize: '13px !important',textTransform:'capitalize'}}>
                      {gender}
                    </Typography>
                  </Box>
                );
              },
            },
        {
          field: 'state',
          headerName: 'State',
          flex: 1.2,
          minWidth: 160,
          cellClassName: 'fw-bold',
          filterColumnName: "state",
          filterType: filterTypeOptions.string,
        },
        {
          field: 'city',
          headerName: 'City',
          flex: 1.2,
          minWidth: 160,
          cellClassName: 'fw-bold',
          filterColumnName: "city",
          filterType: filterTypeOptions.string,
        },
    {
      field: 'source',
      headerName: 'Source',
      flex: 2,
      cellClassName: ' ',
      minWidth: 200,
          filterColumnName: "lead_details.source",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { source } = params.row;
        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box>
            {source}
          </Box>

        );
      },
    },
    {
      field: 'leadSource',
      headerName: 'Lead source',
      flex: 1,
      minWidth: 160,
       filterColumnName: "lead_details.utmData.utm_campaign",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const leadSource = params.value;
        if (loading) return <Skeleton width={70} />;

        const words = leadSource ? leadSource.split(" ") : [];
        const preview = words.slice(0, 7).join(" ") + (words.length > 7 ? "..." : "");

        return (
          <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', height: '100%' }}>
            <Typography noWrap sx={{ maxWidth: 200 }}>
              {preview}
            </Typography>

            <Tooltip
              title={
                <Box sx={{ maxWidth: 300, whiteSpace: "normal" }}>
                  <Typography variant="body2">{leadSource}</Typography>
                </Box>
              }
              placement="top"
              arrow
            > {
                preview ? (
                  <IconButton size="small">
                    <RemoveRedEyeOutlinedIcon fontSize="small" sx={{ color: '#313030', fontSize: '17px' }} />
                  </IconButton>
                ) : (
                  ''
                )
              }
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'lastLoginDate',
      headerName: 'Last Login',
      flex: 2,
      minWidth: 130,
       filterColumnName: "lastLogin",
      filterType: filterTypeOptions.dateRange,

      renderCell: (params) => {
        const { lastLoginDate, lastLoginTime } = params.row;
        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box sx={{ marginTop: '10px' }}>
            <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#000' }}>
              {lastLoginDate}
            </Typography>
            {lastLoginDate && (
              <Typography sx={{ fontWeight: 500, fontSize: '13px', color: '#363853' }}>
                {lastLoginTime}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: 'returnVisit',
      headerName: 'Return visit',
      flex: 1,
      minWidth: 130,
      filterColumnName: "lead_details.returnVisit",
      filterType: filterTypeOptions.numberRange,
    },
    {
      field: 'assigncounsellor',
      headerName: 'Assign Counsellor',
      cellClassName: 'sticky-col-1 text-center  ',
      headerClassName: 'sticky-col-1 text-center leadcourcecenter',
      flex: 2,
      minWidth: 220,
            filterColumnName: "lead_details.counselorId.firstName",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { assigncounsellor } = params.row;
        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box>
            {assigncounsellor}
          </Box>

        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 2,
      minWidth: 220,
      headerClassName: 'text-center leadcourcecenter',
      filterColumnName: "lead_details.status",
      filterType: filterTypeOptions.selection,
      selection:webLeadsStatusList,
      renderCell: (params) => {
        const { status } = params.row;
        const { brdColor, textColor } = getStatusColors(status);

        return (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', alignItems: 'center', height: '100%' }}>
            <Typography
              sx={{
                display: 'inline-block',
                background: `${brdColor}`,
                textAlign: 'center',
                borderRadius: '20px',
                padding: '2px 12px',
                color: textColor,
                fontWeight: 500,
                fontSize: '12px',
                whiteSpace: 'nowrap',
              }}
            >
              {status}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 2,
      minWidth: 250,
      cellClassName: 'text-center',
      headerClassName: "text-center",
      filterable:false,
      renderCell: (params) => {
        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Stack direction="row" spacing={1} sx={{ justifyContent: 'start', height: '100%' }}>
            {!params?.row?.isRegistrationDone && <Button onClick={() => { setUpdateStatusOpen(true); setSelectedLead(params?.row) }}
              size="small"
              variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
              startIcon={<DotsIcon />}
            >
            </Button>}

            <Button onClick={() => handLeadPageClick(params)}
              size="small"
              variant="outlined" sx={{
                border: 'none', textAlign: 'center', minWidth: 'auto', '& svg': {
                  width: '21px', height: '21px', fontSize: '21px'
                }
              }}
              startIcon={<EyeIcon sx={{ color: '#363853', fontSize: '20px', width: '20px', height: '20px' }} />} >
            </Button>
            {!params?.row?.isRegistrationDone && <Button onClick={() => { setAssignOpen(true); setSelectedLead(params?.row) }}
              size="small"
              variant="outlined" sx={{
                border: 'none', textAlign: 'center', minWidth: 'auto', '& svg': {
                  width: '18px', height: '16px', fontSize: '16px'
                }
              }}
              startIcon={<UsersIcon />} >
            </Button>}
          </Stack>
        );
      },
    },
  ];



  return (
    <>
      {/* Apply global styles to DataGrid dropdown menus */}

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div className="page-header">
        {/* <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', background: '#fff', }}> */}
          <div style={{ margin: '10px', padding: '10px 15px', borderBottom: '1px solid #E6E7E8' }}>
            <div className="row align-items-center">
              <div className="col">
                <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}>
                  {/* <Link href="/" className='d-flex'><BackArrowIcon /></Link> */}
                  Website Lead </Typography>
              </div>
            </div>
          </div>

        </div>
        {/* End Col */}
        {/* Filter Toolbar */}
        <CommonFilterTab type='web-leads' module='web' searchPlaceholder='Search ID/Name/Mobile...' detailType='Lead Details' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} isUtmFilter={true} utmFilterOptions={utmTypeList}  />

        {/* Data Table */}
        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
          pageFilters={pageFilters}
          handleFliterSliceChange={handleFliterSliceChange}
          otherPath={activeTab}
        />
      </Box>
      {selectedLead && updateStatusOpen && <UpdateWebLeadStatus refetch={fetchDetails} lead={selectedLead} open={updateStatusOpen} onClose={() => setUpdateStatusOpen(false)} />}
      <AssignCouncilorModal
        refetch={fetchDetails}
        open={assignOpen}
        onClose={() => setAssignOpen(false)}
        assignCouncilorToCall={assignCounselorToWebLead}
        info={{
          _id: selectedLead?.lead_id,
          student: selectedLead?.name,
          status: selectedLead?.status,
          leadId: selectedLead?.leadId,
        }}
      />
    </>
  )
}

export default WebsiteLead

